import React, { useState } from 'react';
import { Text, TextTypes, Icon } from '../../components/index';
import { Row } from 'react-bootstrap';

interface FaqProps {
    faq: {
        question: string;
        answer: string;
    };
}

function FaqBlock({ faq }: FaqProps) {
    const [expanded, setExpanded] = useState(false);
    return (
        <>
            <Row className="question align-items-center">
                <div className="expand" onClick={() => setExpanded(!expanded)}>
                    {expanded ? (
                        <Icon name="RemoveIcon" className="minus-icon" alt="" size={45} />
                    ) : (
                        <Icon name="AddIcon" className="plus-icon" alt="" size={45} />
                    )}
                </div>
                <Text type={TextTypes.SUB2} className="sub2">
                    {faq.question}
                </Text>
            </Row>
            {expanded && (
                <div className="answer">
                    <Text type={TextTypes.P} className="paragraph">
                        {faq.answer}
                    </Text>
                </div>
            )}
        </>
    );
}

export default FaqBlock;
